// import { CustomizedTheme } from "@stigg/react-sdk/src/theme/Theme";
// import { FontVariant, HorizontalAlignment, TextAlignment } from "@stigg/react-sdk/src/theme/types";

import { HorizontalAlignment, TextAlignment } from "@stigg/react-sdk";
import { CustomizedTheme } from "@stigg/react-sdk/dist/theme/Theme";
import { FontVariant } from "@stigg/react-sdk/dist/theme/types";


const productionPublicApiKey = "client-55f52ae0-8908-41fe-ba3c-16397703ba0c:743e9c34-0ee2-4d0c-9634-86cacf8d0e5e";
const developmentPublicApiKey = "client-40cdce72-8498-40c6-b99b-6adbb26268fc:743e9c34-0ee2-4d0c-9634-86cacf8d0e5e";

type Layout = {
  planMinWidth: string;
  planMaxWidth: string;
  ctaAlignment: HorizontalAlignment;
  headerAlignment: HorizontalAlignment;
  descriptionAlignment: TextAlignment;
  planPadding: string;
};

type Typography = {
  fontFamily: string;
  fontFamilyUrl?: string;
  h1: FontVariant;
  h2: FontVariant;
  h3: FontVariant;
  body: FontVariant;
  caption?: FontVariant;
};

const layout: Layout = {
  planMinWidth: "270px",
  planMaxWidth: "270px",
  ctaAlignment: "left",
  headerAlignment: "left",
  descriptionAlignment: "left",
  planPadding: "20px",
};

const typography: Typography = {
  fontFamily: "var(--font-family)",
  caption: {
    fontSize: "12px",
    fontWeight: "normal",
  },
  h1: {
    fontSize: "32px",
    fontWeight: "normal",
  },
  h2: {
    fontSize: "24px",
    fontWeight: "normal",
  },
  h3: {
    fontSize: "16px",
    fontWeight: "normal",
  },
  body: {
    fontSize: "14px",
    fontWeight: "normal",
  },
};

const themeLight: CustomizedTheme = {
  palette: {
    primary: "#775cef",
    backgroundSection: "#ffffff",
    backgroundPaper: "#f2f4f7",
    outlinedBorder: "var(--color-border)",
    backgroundHighlight: "rgb(201 192 242 / 50%)",
    outlinedHoverBackground: "rgb(201 192 242 / 50%)",
    text: {
      primary: "#000000",
      secondary: "#2a2a2a",
      disabled: "#4b4b4b",
    },
  },
  layout: layout,
  typography: typography,
};

const themeDark: CustomizedTheme = {
  palette: {
    primary: "#775cef",
    backgroundSection: "#191c22",
    backgroundPaper: "rgb(29, 28, 32)",
    outlinedBorder: "rgb(43, 48, 59)",
    backgroundHighlight: "#344053",
    text: {
      primary: "#d0d5dd",
      secondary: "rgba(255, 255, 255, 0.75)",
      disabled: "#667085",
    },
  },
  layout: layout,
  typography: typography,
};

export { productionPublicApiKey, developmentPublicApiKey, themeLight, themeDark };